import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_999ccmmbkw: FaireBrandEntity = {
  token: "b_999ccmmbkw",
  type: "brand",
  name: "Halcyon Outfitters®",
  avatarUrl:
    "https://cdn.faire.com/fastly/1b118dc12f38ad9d24db0e5ee413ec11ff67823c3f776efb104a5c6ef59a89d5.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/387f572006eab4cad952daa30ae32963fb21021d9054d3791012160c349b61d5.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/1b118dc12f38ad9d24db0e5ee413ec11ff67823c3f776efb104a5c6ef59a89d5.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/387f572006eab4cad952daa30ae32963fb21021d9054d3791012160c349b61d5.jpeg",
  location: "Saint Augustine, FL, USA",
  minimumOrderDollars: 100,
  rating: 0,
  reviewCount: 0,
  isInsider: true,
  description:
    "Founded in 2023 by a mother–daughter team, Halcyon Outfitters was born from a simple idea: every woman deserves fashion that fits her body and her life. Inspired by the fusion of Satin and Sculpture, our name reflects our belief that beauty is both soft and strong, fluid and powerful.\n\nWe create thoughtfully designed plus-size clothing that blends comfort, elegance, and modern style—made with breathable fabrics, flattering cuts, and versatile silhouettes. Our collections focus on everyday essentials and statement pieces that feel confident, wearable, and accessible, without compromising quality or design.\n\nRooted in community, Halcyon Outfitters is built on connection, self-love, and empowerment. We’re more than a clothing brand—we’re a growing movement that celebrates curves, individuality, and confidence. Our vision is to create timeless pieces that make women feel seen, valued, and beautifully themselves—every single day.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:03.378Z",
    importedBy: "entity-db-cli",
  },
};
